import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import Countries from '../components/home/Countries';
import Process from '../components/home/Process';
// import Testimonials from '../components/home/Testimonials';
// import Contact from '../components/home/Contact';
import ImmigrationServices from '../components/home/ImmigrationServices';
import Demo from '../components/home/Demo';

const Home = () => {
    return(
        <div>
            <Hero />
      <Services />
      <ImmigrationServices/>
      <Countries />
      <Process />
      <Demo/>
        </div>
    );
}
export default Home;    